import {
  LocationSuggestionCampsite,
  LocationSuggestionCustom,
  LocationSuggestionHierarchy,
} from './domain/LocationSuggestions'

export abstract class SuggestionsHierarchyService {
  abstract fetch(
    query: string,
    langCode: string,
  ): Promise<LocationSuggestionHierarchy[]>
}

export abstract class SuggestionsCampsiteService {
  abstract fetch(
    query: string,
    langCode: string,
  ): Promise<LocationSuggestionCampsite[]>
}

export abstract class SuggestionsGeoService {
  abstract fetch(
    input: string,
    langCode: string,
  ): Promise<LocationSuggestionCustom[]>
}
